import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import style from "../../assets/jss/disal-main/components/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Grid from "@material-ui/core/Grid";
import Fade from "@material-ui/core/Fade";
import Modal from "@material-ui/core/Modal";
import api from "../../Services/ApiURLBase";
import { URLSalidaSpecficId } from "../../other/apis";

const useStyles = makeStyles(style);

const ModalSalida = props => {
  const classes = useStyles();
  const [subTypes, setSubTypes] = useState([]);

  const { data, onClose } = props;

  const fetchSalida = async () => {
    try {
      const response = await api.get(URLSalidaSpecficId(data.outputId));
      setSubTypes(response.data.result.subTypes);
    } catch (error) {
      console.error('Error fetching salidas:', error);
    }
  };

  useEffect(() => {
    fetchSalida();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      className={classes.modal}
      open={true}
      onClose={() => onClose()}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500
      }}
    >
      <Fade in={true}>
        <div className={classes.modalIngreso}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className={classes.modalTitle} id="exampleModalLabel">
                  <span>Detalle de salida</span>
                </h5>
                <button className="btn-close" onClick={() => onClose()}>
                  <span className="closeSpan big"></span>
                </button>
              </div>
              <div className="modal-body ">
                <Grid container>
                  <Grid item xs={6}>
                    <label>
                        <strong>Planta</strong>
                    </label>
                    <p>{data.miningSiteName}</p>
                  </Grid>
                  <Grid item xs={6}>
                    <label>
                        <strong>Patio</strong>
                    </label>
                    <p>{data.warehouseName}</p>
                  </Grid>
                  <Grid item xs={6}>
                    <label>
                        <strong>Transportista</strong>
                    </label>
                    <p>{data.transportCompanyName}</p>
                  </Grid>
                  <Grid item xs={6}>
                    <label>
                        <strong>Destino</strong>
                    </label>
                    <p>{data.destinationCompanyName}</p>
                  </Grid>
                  <Grid item xs={6}>
                    <label>
                        <strong>Valorización</strong>
                    </label>
                    <p>{data.dispositionName ? data.dispositionName : "-"}</p>
                  </Grid>
                  <Grid item xs={6}>
                    <label>
                        <strong>Salida</strong>
                    </label>
                    <p>{data.outputDate} {data.outputHour}</p>
                  </Grid>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <h4>
                    <span>Detalle de residuos</span>
                  </h4>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr", alignItems: "center", gap: "15px" }}>
                    {subTypes.map(res => {
                      return (
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                          <div
                            className="circle-ingreso"
                            style={{
                              backgroundColor: res.color,
                              border: res.name === "Plásticos" ? "1px solid #6A6A6A" : "none"
                            }}
                          ></div>
                          <div 
                            className="mb-0 text-residuo"
                            style={{
                              minWidth: "220px",
                            }}
                          >
                            {res.name}
                          </div>
                          <div 
                            className="mb-0"
                            style={{
                              minWidth: "80px",
                            }}
                          >
                            {(parseFloat(res.amount) / 1000).toFixed(2)} T
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </Grid>
                <Grid container style={{ marginTop: "25px" }}>
                  <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", alignItems: "center", gap: "10px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                      <strong style={{ width: "250px"}}>Total:</strong>
                      <strong style={{ width: "80px"}}>{(parseFloat(data.totalAmount || 0) / 1000).toFixed(2)} T</strong>
                    </div>
                  </div>
                </Grid>
              </div>
            </div>
          </div>
        </div>
      </Fade>
    </Modal>
  );
}

export default ModalSalida;
